import { render, staticRenderFns } from "./GasConsumptionPage.vue?vue&type=template&id=4c8836f0&scoped=true&"
import script from "./GasConsumptionPage.vue?vue&type=script&lang=js&"
export * from "./GasConsumptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8836f0",
  null
  
)

export default component.exports